import React from "react";
import "./Fallbacks.css";

type FallbackPageContentProps = {
  children: React.ReactNode;
  "aria-label"?: string;
};

export const FallbackPageContent: React.FC<FallbackPageContentProps> = ({
  children,
  "aria-label": ariaLabel = "Loading page",
}) => (
  <div className="app-fallback-page-content" aria-busy aria-label={ariaLabel}>
    {children}
  </div>
);
